<template>
<div id="index">


  <div class="common-level-rail">
    <el-button size="small" type="primary" @click="$refs.addEdit.show()" icon="el-icon-plus" v-auth="'/appraisal/category/add'">添加分类</el-button>
  </div>

  <div class="product-content">
    <div class="table-wrap">
      <el-table size="small" :data="list" row-key="category_id" default-expand-all :tree-props="{children: 'child'}" >
        <el-table-column prop="name" label="分类名称"></el-table-column>
        <el-table-column prop="" label="分类图片">
          <template slot-scope="scope">
            <img v-img-url="scope.row.file_path?scope.row.file_path:''" alt="" width="50px" height="50px" />
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="$refs.addEdit.show(scope.row)" type="text" size="small" v-auth="'/appraisal/category/edit'">编辑</el-button>
            <el-button @click="deleteTap(scope.row)" type="text" size="small" v-auth="'/appraisal/category/delete'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>


  <AddEdit ref="addEdit" :cateList="list" @refresh="getData"></AddEdit>


</div>
</template>

<script>
import AddEdit from './addEdit.vue';
import AppraisalApi from '@/api/appraisal'
export default {
  components:{AddEdit},
  data() {
    return {
      list: [],
    }
  },
  created(){
    this.getData()
  },
  methods:{

    getData(){
      AppraisalApi.categoryIndex().then(result=>{
        this.list=result.data.tree
      })
    },

    // 删除
    deleteTap(e){
      this.$confirm('确认删除当前分类吗？','提示',{type: 'warning'}).then(() => {
        AppraisalApi.categoryDelete({category_id:e.category_id}).then(result=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getData()
        })
      })
    },

  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/appraisal/category/index.vue